import { SalleResource } from "types/caisse.type";
import { selectHelper } from "utils/helpers";
import * as yup from "yup";

export const salleSchema = yup.object({
  libelle: yup.string().required(),
  centre: yup.object().required(),
});

const toBody = (data: Record<string, any>) => {
  return {
    libelle: data.libelle,
    centre_id: selectHelper.getValue(data.centre),
  };
};

const toInput = (data: SalleResource) => {
  return {
    libelle: data.libelle,
    centre: selectHelper.buildCentre(data.centre),
  };
};

export const salleConverter = {
  toBody,
  toInput,
};
